import { useRecoilValue } from "recoil";
import { useMutation } from "react-query";
import { LogenInstance, LotteInstance } from "../instance";
import { loginState } from "../../stores/loginState";

// TODO 고객사 자동전송여부 설정 API
export const useGetAutoChange = (isOn, setIsOn) => {
  const login = useRecoilValue(loginState); // 로그인 전역변수

  // TODO API 결과
  const mutationOptions = {
    // 성공 시
    onSuccess: (data) => {
      if (data.result === "00" || data.result === "77") {
        setIsOn(!isOn);
      }
    },
    // 실패 시
    onError: (error) => {
      console.log(error);
    },
  };

  // TODO API 리퀘스트 정보
  const mutateFunction = (auto) => {
    if (login.company === "LOGEN") {
      return LogenInstance.post("/autoChange", {
        bran_cd: login.branchCode,
        auto,
      });
    } else if (login.company === "LOTTE") {
      return LotteInstance.post("/autoChange", {
        bran_cd: login.branchCode,
        auto,
      });
    } else {
      throw new Error("Invalid company");
    }
  };

  return useMutation("getAutoChange", mutateFunction, mutationOptions);
};
